import { COLORS } from "@/constants";
import { Box } from "@mui/material";
import styled from "styled-components";

export const Wrapper = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.white};
  z-index: 200;
  position: relative
`;
